const messages = {
  title: "Parduotuvė",
  description: "Sveiki atvykę į apdovanojimų parduotuvę. Čia galite išpirkti Bridgestone Plus taškus <br/> už įvairių kategorijų apdovanojimus. Prekių asortimentas <br/> nuolat atnaujinamas. Tikimės, kad jums patiks naršyti.",
  sort: {
    asc: "Rikiuoti pagal: Žemiausia kaina",
    desc: "Rikiuoti pagal: Aukščiausia kaina",
  },
  productSearchBox: {
    from: "taškai nuo",
    to: "taškai iki",
  },
  noProducts: "Paieškos kriterijai nedavė rezultatų",
  quantity: "Kiekis",
  search: "Ieškoti",
  perPage: "Elementų puslapyje",
  timeUnavailable: "Šiuo metu nepasiekiama",
  product: "Produktas",
  cart: {
    pointsPerUnit: "Taškai už vienetą",
    pointsSum: "Taškų suma",
  },
  action: "Veiksmas",
  pointsTotal: "Iš viso",
  cartRemainPoints: "Likę taškai krepšelyje",
  shoppingCart: "Krepšelis",
  emptyCart: "Krepšelis tuščias.",
  attributes: "Atributai",
  selectAddressP: "Pasirinkite pristatymo adresą",
  orderDelivery: "Pristatymo adresas",
  selectedProducts: "Pasirinkti produktai",
  orderSummary: "Užsakymo apžvalga",
  contactPerson: "Kontaktinis asmuo",
  selectedAddress: "Pasirinktas adresas",
  order: {
    success: "Ačiū! Jūsų užsakymas sėkmingas. Per kelias minutes gausite užsakymo patvirtinimą savo pašto dėžutėje.",
    description: "Čia rasite apdovanojimų parduotuvės užsakymų apžvalgą.",
    info: "Čia rasite apdovanojimų parduotuvės užsakymų apžvalgą.",
    date: "Užsakymo data",
    number: "Užsakymo nr.",
    status: {
      created: "Sukurta",
      confirm_order: "Patvirtinti užsakymą",
      ready_for_shipment: "Paruošta siuntimui",
      rejected: "Atmesta",
      processed: "Apdorota",
      shipped: "Išsiųsta",
      returned: "Grąžinta",
      finished: "Baigta",
    },
    anyOrder: "Nėra užsakymų",
    products: "Produktai",
    quantity_short: "vnt.",
    itemRemoved: "nepristatomas",
  },
  orders: "Užsakymai",
  notEnoughPoints: "Nepakanka turimų taškų.",
  statusText: "Būsena",
  outOfStock: "Šiuo metu nėra sandėlyje",
  productUnavailable: "Šis produktas nebepasiekiamas.",
  deletedProductsTitle: "Produktai nebepasiekiami",
  deletedProductsMessage: "Šie produktai nebepasiekiami. Pašalinkite juos iš krepšelio, kad galėtumėte tęsti.",
  removeSelected: "Pašalinti pasirinktus",
  clearCart: "Išvalyti krepšelį",
  removeSelectedConfirm: "Pašalinti pasirinktus produktus iš krepšelio?",
  clearCartConfirm: "Pašalinti visus produktus iš krepšelio?",
  incompleteAddress: {
    firstName: "Pridėkite vardą prie pristatymo adreso",
    lastName: "Pridėkite pavardę prie pristatymo adreso",
    company: "Pridėkite įmonės pavadinimą prie pristatymo adreso",
    street: "Pridėkite gatvę ir namo numerį prie pristatymo adreso",
    postalCode: "Pridėkite pašto kodą prie pristatymo adreso",
    city: "Pridėkite miestą prie pristatymo adreso",
    country: "Pridėkite šalį prie pristatymo adreso",
    phone: "Pridėkite telefono numerį prie pristatymo adreso",
  },
  placeOrder: "Įpareigojantis užsakymas",
  toOrderDelivery: "Tęsti į pristatymo adresą",
  toOrderSummary: "Į užsakymo apžvalgą",
  productImg: "Produkto vaizdas",
  selectAddressBtn: "Pasirinkti adresą",
  perPgae: "Elementų puslapyje",
  categories: {
    advertising: {
      title: "Reklaminė medžiaga",
      desc: "Dalyvaukite tiesiogiai čia platformoje ir gaukite <br/> 40 papildomų taškų apdovanojimų klubui.",
    },
    rewards: {
      title: "Ekskluzyvūs apdovanojimai",
      desc: "Atraskite premijos pasiūlymą mūsų mokymo centre arba savo vietoje.",
    },
    tools: {
      title: "Dirbtuvių įrankiai",
      desc: "Naudokite taškus trečiųjų šalių mokymams <br/> ir sumažinkite išlaidas.",
    },
    trainings: {
      title: "Mokymai ir kursai",
      desc: "Atraskite premijos pasiūlymą mūsų mokymo centre arba savo vietoje.",
    },
    salesroom: {
      title: "Pardavimo salė",
      desc: "Sutvarkykite pardavimo salę ir suteikite klientams malonų buvimą.",
    },
    hunter: {
      title: "Hunter",
      desc: "Keiskite taškus į patrauklią Hunter dirbtuvių įrangą.",
    },
  },
  bestSold: "Perkamiausi",
  seasonal: "Sezoniniai",
  affordable: "Beveik baigta",
  forPoints: "už {points} taškų",
  reachedPoints: "Reikalingi taškai pasiekti",
  remainingPoints: "Trūksta {points} taškų",
  favoriteProducts: {
    description: "Čia rasite išsaugotus produktus.",
  },
  categoryPageDescriptionFallback: "Medžiaga dirbtuvei ar kiti kokybiški produktai su Bridgestone logotipu jūsų įmonei",
  variant: "Pasirenkami variantai",
};
export default {
  messages,
};
